import { api } from "../../../../../../utility/AxiosInceptor.js";
import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import * as Yup from "yup";
import { useFormik } from "formik";
import "./css/add_units_flowpage.css";
import CellPhoneSingleUpload from "./add_units_components/cell_phone_singleupload/cell_phone_singleupload.js";
import {
  type,
  typeUpdateInventory,
  typeUpdateBulkInventory,
} from "./assets.js";
import TabletBulkUploadAddProvision from "./add_units_components/tablet_bulk_upload/add_stock_provision.js";
import FileUploadDetails from "./FileUploadDetails/FileUploadDetails.js";
import FileStats from "./FileStats/FileStats.js";
import { useNavigate } from "react-router-dom";

const AddUnits = ({
  setActiveComponent,
  setUpdateInventory,
  setAddUnits,
  isFromhome,
  isUpload,
  rowData,
  updateType,
  setRefreshInventoryData,
}) => {
  console.log("update type is", updateType);
  const [inventoryIdSelected, setInventoryIdSelected] = useState();
  const [fileUploadDetails, setFileUploadDetails] = useState(false);
  const [fileUploadStatus, setFileUploadStatus] = useState("");
  let navigate = useNavigate();
  const [showStats, setShowStats] = useState(false);
  const [data, setData] = useState([]);
  const [header, setHeader] = useState("");
  const [duplicateRows, setDuplicateRows] = useState([]);
  const [color, setColor] = useState("success");
  const loginRes = localStorage.getItem("userData");
  const parseLoginRes = JSON.parse(loginRes);
  const validationSchema = Yup.object().shape({
    unitType: Yup.string().required("please select"),
    uploadType: Yup.string().required("please select type "),
    makeModel: Yup.string().required("please select type "),
  });
  const formik = useFormik({
    initialValues: {
      unit: "",
      upload:
        !isUpload && updateType === "single"
          ? "Single"
          : !isUpload && updateType === "bulk"
            ? "Bulk"
            : "",
      makeModel:
        !isUpload && updateType === "single"
          ? rowData.makeAndModel.replace("-", " - ")
          : "",
      billingModel: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {},
  });
  useEffect(() => {
    if (!isUpload && updateType === "single") {
      formik.setFieldValue("billingModel", rowData.billingModel);
      formik.setFieldValue(
        "makeModel",
        rowData.makeAndModel.replace("-", " - "),
      );
      formik.setFieldValue("unit", rowData.inventoryType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [unitOptions, setUnitOptions] = useState([]);
  const [billingModelList, setBillingModelList] = useState([]);

  const [currentBillingId, setCurrentBillingId] = useState("");

  const [makeModelOptions, setMakeModelOptions] = useState();
  const [identifierTypeSelected, setIdentifierTypeSelected] = useState();
  useEffect(() => {
    api
      .get(`/api/billingModel/all?serviceProvider=${parseLoginRes?.company}`)
      .then((res) => {
        setBillingModelList(res?.data?.data);
        if (!isUpload && updateType === "single") {
          let list = res?.data?.data;
          let id;
          list.forEach((item) => {
            if (item.billingModel === rowData.billingModel) {
              id = item._id;
            }
          });

          setCurrentBillingId(id);
        }
      })
      .catch((err) => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    async function fetchData() {
      if (formik.values.billingModel !== "") {
        try {
          const res = await api.get(
            `/api/billingModel/getInventoryByBillingModel?billingModel=${currentBillingId}`,
          );
          let obj = [];
          let data = res?.data?.data;
          data.forEach((item) => {
            let obj2 = {};
            obj2.inventoryType = item;
            obj.push(obj2);
          });
          setUnitOptions(obj);
        } catch (error) {}
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentBillingId]);
  useEffect(() => {
    if (formik.values.unit !== "" && formik.values.billingModel !== "") {
      api
        .get(
          `/api/inventoryType/getInventoryTypeData?inventoryType=${formik.values.unit}&billingModel=${currentBillingId}&serviceProvider=${parseLoginRes?.company}`,
        )
        .then((res) => {
          let Data = res?.data?.data;
          let dataNew = [];
          for (let i = 0; i < Data.length; i++) {
            let data = Data[i];
            data.makemodel = `${data.make} - ${data.model}`;
            dataNew.push(data);
          }
          setMakeModelOptions(dataNew);
        })
        .catch((err) => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.billingModel, currentBillingId, formik.values.unit]);

  useEffect(() => {
    if (formik.values.makeModel !== "") {
      for (let i = 0; i < makeModelOptions?.length; i++) {
        if (makeModelOptions[i].makemodel === formik.values.makeModel) {
          setIdentifierTypeSelected(
            makeModelOptions[i].identifierType?.identifier,
          );
          setInventoryIdSelected(makeModelOptions[i]._id);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.makeModel, makeModelOptions]);
  const [isFirstTime, setIsFirstTime] = useState(false);
  useEffect(() => {
    if (
      !isUpload &&
      updateType === "single" &&
      !isFirstTime &&
      !formik.values.unit === ""
    ) {
      formik.setFieldValue("makeModel", "");
    } else {
      setIsFirstTime(true);
    }
    return () => {
      if (!isFromhome) setRefreshInventoryData((prev) => !prev);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.unit]);
  console.log(formik.values);
  return (
    <>
      {fileUploadDetails ? (
        <FileUploadDetails
          fileUploadStatus={fileUploadStatus}
          setShowStats={setShowStats}
          setData={setData}
          setFileUploadDetails={setFileUploadDetails}
          setAddUnits={setAddUnits}
          setHeader={setHeader}
          setDuplicateRows={setDuplicateRows}
          setColor={setColor}
        />
      ) : showStats ? (
        <FileStats
          data={data}
          header={header}
          setShowStats={setShowStats}
          setFileUploadDetails={setFileUploadDetails}
          duplicateRows={duplicateRows}
          color={color}
        />
      ) : (
        <div
          className="addunitmain"
          style={{
            height: formik.values.upload === "Bulk" ? "83.1rem" : "72.9rem",
          }}
        >
          <div className="addunitinner">
            <div>
              <button
                className="backicon"
                onClick={() => {
                  if (!isFromhome) {
                    setAddUnits(false);
                    setUpdateInventory(false);
                  } else {
                    navigate("/manageinventory");
                  }
                }}
              >
                <i
                  className="pi pi-angle-left"
                  style={{ fontSize: "1.5rem", color: "#323232" }}
                ></i>
              </button>
            </div>

            <div className="header">
              <h1 className="heading">
                {isUpload ? "Add Unit" : "Update Inventory"}
              </h1>
              <p className="para">
                {isUpload
                  ? "Fill out the form below to add a new unit, including details such as billing model, inventory type, make and model, and more."
                  : "     Use the form below to update inventory details."}{" "}
              </p>
            </div>
            <div>
              <div className="flex flex-column" style={{ marginTop: "2.4rem" }}>
                <div className="flex w-full" style={{ gap: "1.2rem" }}>
                  <div className="calendar_fieldaddunit">
                    <p className="field_labeladdunit">Billing Model</p>
                    <Dropdown
                      value={formik.values.billingModel}
                      name="billingModel"
                      optionLabel="billingModel"
                      optionValue="billingModel"
                      options={billingModelList}
                      onChange={(e) => {
                        let id;
                        billingModelList.forEach((item) => {
                          formik.setFieldValue("unit", "");
                          if (item.billingModel === e.value) {
                            id = item._id;
                          }
                        });

                        formik.setFieldValue("billingModel", e.value);
                        formik.handleChange(e);
                        setCurrentBillingId(id);
                      }}
                      placeholder="Select an option"
                      className="dropdown"
                      style={{ width: "32rem" }}
                    />
                  </div>
                  <div className="calendar_fieldaddunit">
                    <p className="field_labeladdunit ">Inventory Type</p>
                    <Dropdown
                      className="dropdown"
                      style={{ width: "32rem" }}
                      optionLabel="inventoryType"
                      optionValue="inventoryType"
                      value={formik.values.unit}
                      name="unit"
                      options={unitOptions}
                      onChange={formik.handleChange}
                      placeholder="Select an option"
                    />
                  </div>
                </div>
                <div
                  className="flex w-full"
                  style={{ gap: "1.2rem", marginTop: "1.2rem" }}
                >
                  <div className="calendar_fieldaddunit">
                    <p className="field_labeladdunit ">Make And Model</p>
                    <Dropdown
                      className="dropdown"
                      style={{ width: "32rem" }}
                      optionLabel="makemodel"
                      optionValue="makemodel"
                      value={formik.values.makeModel}
                      name="makeModel"
                      options={makeModelOptions}
                      onChange={formik.handleChange}
                      placeholder="Select an option"
                    />
                  </div>
                  <div className="calendar_fieldaddunit">
                    <p className="field_labeladdunit">
                      Upload Type <span className="steric">*</span>
                    </p>
                    <Dropdown
                      className="dropdown"
                      style={{ width: "32rem" }}
                      value={formik.values.upload}
                      name="upload"
                      options={
                        isUpload
                          ? type
                          : updateType === "single"
                            ? typeUpdateInventory
                            : updateType === "bulk"
                              ? typeUpdateBulkInventory
                              : []
                      }
                      onChange={formik.handleChange}
                      placeholder="Select an option"
                    />
                  </div>
                </div>
              </div>
            </div>
            {formik.values.upload === "Single" &&
            formik.values.unit !== "" &&
            formik.values.makeModel !== "" ? (
              <CellPhoneSingleUpload
                isUpload={isUpload}
                rowData={rowData}
                isFromhome={isFromhome}
                inventoryIdSelected={inventoryIdSelected}
                setActiveComponent={setActiveComponent}
                identifierTypeSelected={identifierTypeSelected}
                unit={formik.values.unit}
                model={formik.values.billingModel}
                makeModel={formik.values.makeModel}
                setUpdateInventory={setUpdateInventory}
                setAddUnits={setAddUnits}
              />
            ) : formik.values.upload === "Bulk" &&
              formik.values.unit !== "" &&
              formik.values.makeModel !== "" ? (
              <TabletBulkUploadAddProvision
                isFromhome={isFromhome}
                inventoryIdSelected={inventoryIdSelected}
                setActiveComponent={setActiveComponent}
                makeModel={formik.values.makeModel}
                identifierTypeSelected={identifierTypeSelected}
                unit={formik.values.unit}
                model={formik.values.billingModel}
                setFileUploadDetails={setFileUploadDetails}
                setFileUploadStatus={setFileUploadStatus}
                setAddUnits={setAddUnits}
              />
            ) : undefined}
          </div>
        </div>
      )}
    </>
  );
};

export default AddUnits;
